export const getTitle = (title: string) => {
  return title + " - " + import.meta.env.VITE_WEBSITE_NAME;
};

/**
 * Format number to VND.
 * Example: formatVND(10000);           // '10.000'
 */
export function formatVND(num: number) {
  return `${num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`;
}

export const getImageSize = (setImageDimensions: any, imageUrl: string) => {
  const img = new Image();
  img.src = imageUrl;

  img.onload = () => {
    setImageDimensions({
      height: img.height,
      width: img.width,
    });
  };
  img.onerror = (err) => {
    console.log("img error");
    console.error(err);
  };
};
